import React from 'react'
import "./ViewProgressBar.css"

function ViewProgressBar({ title, progress, levels }) {
    return (
        <div className="progress-bar-container">
            <h5 className={`${title === "Difficulty" ? "titlecolorDiff" : "titlecolorSkill"}`}>{title}</h5>
            <div className="d-flex">
                <div className="progress-bar">
                    <div
                        className="progress"
                        style={{
                            height: `${progress}%`,
                            background: title === "Difficulty" ? "#83cbeb" : "#84e291",
                            borderRadius: "unset"
                        }}
                    ></div>
                </div>
                <div className="progress-labels">
                    {levels.map((level, index) => (
                        <span key={index}>{level}</span>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ViewProgressBar